import { useState, useCallback } from "react";
import { copyTextToClipboard } from "utils/utils";
import { VIEW_DASH } from "constants/schoolConstants";
import { COPY_FEEDBACK_DURATION_MS } from "../../constants/schoolConstants";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

import layoutStyles from "../../components/ViewBranchDetails/ViewBranchDetails.module.scss";
import styles from "../../components/ViewSchoolDetails/ViewSchoolDetails.module.scss";

export const Section = ({ icon: Icon, title, children }) => (
    <section className={layoutStyles.section}>
      <div className={layoutStyles.sectionHeader}>
        {Icon ? <Icon className={layoutStyles.sectionIcon} aria-hidden /> : null}
        <h3 className={layoutStyles.sectionTitle}>{title}</h3>
      </div>
      <div className={layoutStyles.sectionBody}>{children}</div>
    </section>
  );
  
export const Field = ({ label, value, fullWidth, isLoading }) => (
    <div className={`${layoutStyles.field} ${fullWidth ? layoutStyles.fieldFull : ""}`}>
      <div className={layoutStyles.fieldLabel}>{label}</div>
      <div
        className={`${layoutStyles.fieldValue}${isLoading ? ` ${styles.fieldValueLoading}` : ""}`}
      >
        {isLoading ? "Loading…" : (value ?? VIEW_DASH)}
      </div>
    </div>
  );
  
export const FieldGrid = ({ children }) => (
    <div className={layoutStyles.fieldGrid}>{children}</div>
  );
  
export const CopyIdField = ({ label, idValue, ariaLabel }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = useCallback(async () => {
      if (idValue == null || idValue === "") return;
      const ok = await copyTextToClipboard(String(idValue));
      if (!ok) return;
      setCopied(true);
      window.setTimeout(() => setCopied(false), COPY_FEEDBACK_DURATION_MS);
    }, [idValue]);
  
    return (
      <div className={`${layoutStyles.field} ${layoutStyles.fieldFull}`}>
        <div className={layoutStyles.fieldLabel}>{label}</div>
        {idValue != null && idValue !== "" ? (
          <div className={styles.copyIdRow}>
            <span className={styles.copyIdText}>{idValue}</span>
            <button
              type="button"
              className={styles.copyIdButton}
              onClick={handleCopy}
              aria-label={ariaLabel}
            >
              <ContentCopyOutlinedIcon className={styles.copyIdIcon} aria-hidden />
            </button>
            {copied ? (
              <span className={styles.copyFeedback} role="status">
                Copied
              </span>
            ) : null}
          </div>
        ) : (
          <div className={layoutStyles.fieldValue}>{VIEW_DASH}</div>
        )}
      </div>
    );
  };
  
export const ChipList = ({
  label = "Boards",
  labels,
  isLoading,
  emptyLabel = VIEW_DASH,
}) => (
    <div className={`${layoutStyles.field} ${layoutStyles.fieldFull}`}>
      <div className={layoutStyles.fieldLabel}>{label}</div>
      <div className={layoutStyles.fieldValue}>
        {isLoading ? (
          <span className={styles.fieldValueLoading}>Loading…</span>
        ) : labels.length ? (
          <div className={styles.boardChipGrid}>
            {labels.map((chipLabel) => (
              <span key={chipLabel} className={styles.boardChip}>
                {chipLabel}
              </span>
            ))}
          </div>
        ) : (
          emptyLabel
        )}
      </div>
    </div>
  );